import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import moment from "moment";

/**
 * Histórico de métricas.
 *
 * El endpoint de Stripe sólo devuelve la foto del momento: no hay forma de
 * preguntarle cuántos suscriptores había hace un mes. Por eso el admin deja
 * una marca diaria en Firestore; a partir de la segunda semana se puede
 * graficar la evolución real de altas y bajas de membresía.
 *
 * El ID del documento es la fecha, así que varios administradores abriendo el
 * tablero el mismo día no lo duplican.
 */

const COLECCION = "metricas_diarias";

export async function guardarSnapshotSiFalta(resumen) {
  const id = moment().format("YYYY-MM-DD");
  const ref = firebase.firestore().collection(COLECCION).doc(id);

  try {
    const doc = await ref.get();
    if (doc.exists) return false;

    await ref.set({
      fecha: id,
      registros_total: resumen.registrosTotal,
      registros_dia: resumen.registrosPeriodo,
      perfiles_completados: resumen.perfilesCompletados,
      suscriptores_activos: resumen.suscriptoresActivos,
      tasa_conversion: resumen.tasaConversion,
      negocios: resumen.negociosTotal,
      sesiones: resumen.sesionesTotal,
      vacantes_activas: resumen.vacantesActivas,
      generado_en: firebase.firestore.FieldValue.serverTimestamp(),
      generado_por: obtenerActor(),
    });
    return true;
  } catch (err) {
    // Guardar el histórico nunca debe impedir ver el tablero.
    console.warn("[snapshotDiario] no se pudo guardar el snapshot:", err);
    return false;
  }
}

/** Snapshots de los últimos `dias` días, del más antiguo al más reciente. */
export async function leerSnapshots(dias = 90) {
  const desde = moment().subtract(dias, "days").format("YYYY-MM-DD");
  try {
    const snap = await firebase
      .firestore()
      .collection(COLECCION)
      .where("fecha", ">=", desde)
      .orderBy("fecha", "asc")
      .get();
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  } catch (err) {
    console.warn("[snapshotDiario] no se pudieron leer los snapshots:", err);
    return [];
  }
}

function obtenerActor() {
  const usuario = firebase.auth && firebase.auth().currentUser;
  return usuario && usuario.email ? usuario.email : "desconocido";
}
